module.exports = __webpack_public_path__ + "static/media/4n.bd5591fd.jpg";